import { Image, Row, Col } from "react-bootstrap";
import useWindowDimensions from "../../utils/useWindowDimensions";

// import Balloon from '../../assets/airballoon.png'
import voteImage from "../../assets/images/vote.png"

import styles from "./Voting.module.css";

function Voting() {
    const { height, width } = useWindowDimensions();
    return (
        <Row className={`${styles.ContentContainer} homePageVotingSection`}>
            <Col className="d-flex align-items-center">
                <div>
                    <div className={styles.votingTitle}>Voting</div>
                    <div className={styles.votingSubtext}>Voton provides a platform to organizations, individuals, and teams to present their project proposals to the globe and enables them to raise funds. The audience will be able to voice their opinion in form of voting for the proposal they like the most. <br/><br/> Through this voting process, the proposing teams can gain valuable feedback from the community. Such a feedback can be used to develop and improve the project for better market response. At the end of the three-months voting period, the proposer with the highest votes will receive the donation pool.</div>
                    {width < 992 ?
                        <Image src={voteImage} className={styles.votingBanner}></Image>
                        : <></>
                    }
                </div>
            </Col>
            {width < 992 ? <></> :
                <Col style={{ textAlign: 'end', position: 'relative' }}>
                    <Image src={voteImage} className={styles.votingBanner}></Image>
                </Col>
            }

        </Row>
    );
}

export default Voting;